import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { BasicAssetHeaderLocation } from "~/components/AssetModal/Header/components/BasicAssetHeaderLocation";
import { HeaderBoardAndFieldsInfo } from "~/components/AssetModal/Header/components/HeaderBoardAndFieldsInfo";
import { PublicAssetHeaderShareButton } from "~/components/AssetModal/Header/components/PublicAssetHeaderShareButton";
import { Header } from "~/components/AssetModal/Header/Header";
import { PublicAssetModalHeaderTitle } from "~/components/PublicAssetModal/components/PublicAssetModalHeaderTitle";
import { PublicDownloadButton } from "~/components/PublicAssetModal/components/PublicDownloadButton";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { usePublicWorkspace } from "~/components/PublicWorkspaceProvider";
import { usePublicAssetCustomFieldsData } from "~/hooks/usePublicAssetCustomFieldsData";
import { canChangeAssetCustomFields, canDownloadVersion, canSeeAssetCustomFields, canViewAssetDiscussions } from "~/utils/permissions/assetPermissions";
import { PublicAssetModalBanner } from "../shared/components/PublicAssetModalBanner/PublicAssetModalBanner";
export const PublicAssetModalHeader = /*#__PURE__*/ memo(()=>{
    const { permissions } = usePublicPermissions();
    const canDiscuss = canViewAssetDiscussions(permissions);
    const canDownload = canDownloadVersion(permissions);
    const canEditCustomFields = canChangeAssetCustomFields(permissions);
    const canViewCustomFields = canSeeAssetCustomFields(permissions);
    const { data: customFields } = usePublicAssetCustomFieldsData();
    const { workspaceName } = usePublicWorkspace();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PublicAssetModalBanner, {}),
            /*#__PURE__*/ _jsx(Header, {
                headerLeft: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(PublicAssetModalHeaderTitle, {}),
                        /*#__PURE__*/ _jsx(HeaderBoardAndFieldsInfo, {
                            assetLocation: /*#__PURE__*/ _jsx(BasicAssetHeaderLocation, {
                                workspaceName: workspaceName
                            }),
                            fields: customFields === null || customFields === void 0 ? void 0 : customFields.data,
                            canEditCustomFields: canEditCustomFields,
                            canViewCustomFields: canViewCustomFields,
                            showComments: canDiscuss
                        })
                    ]
                }),
                headerRight: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(PublicAssetHeaderShareButton, {}),
                        canDownload && /*#__PURE__*/ _jsx("div", {
                            className: "ml-3",
                            children: /*#__PURE__*/ _jsx(PublicDownloadButton, {})
                        })
                    ]
                })
            })
        ]
    });
});
PublicAssetModalHeader.displayName = "PublicAssetModalHeader";
